import React from 'react'
import _ from 'lodash'
import {
    addPart as addNotepadPart,
    removePart as removeNotepadPart,
    setParts as setNotepadParts,
    selectNotepadParts
} from '../table/notepadSlice'
import isProd from '../../utils/constants/isProd'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import {fillHeaderInfoStarSvg} from "../infostar/InfoStarFunctions";
import {redColor} from "../../utils/constants/compareParts";

const InfoStar = ({ part_id, hash }) => {
    const dispatch = useDispatch()
    const notepadParts = useSelector(selectNotepadParts)

    const partInNotepad = _.find(notepadParts, { hash })
    const isPartInNotepad = typeof partInNotepad !== 'undefined'

    const addNotepadPartHandler = (part_id, hash) => (e) => {
        if (isProd) {
            const sessid = window.BX.bitrix_sessid()
            const ajaxNotepadUrl = '/bitrix/components/linemedia.auto/personal.notepad/ajax.php'
            const getNotepadPartsUrl = '/ajax/notepad-parts.php?sessid=' + sessid

            const data = new URLSearchParams()
            data.append('notepad', 'add')
            data.append('part_id', part_id)
            data.append('sessid', sessid)

            axios
                .post(ajaxNotepadUrl, data)
                .then(() => fetch(getNotepadPartsUrl))
                .then((res) => res.json())
                .then(
                    (result) => {
                        if (result.result) {
                            dispatch(setNotepadParts(result.data))
                            fillHeaderInfoStarSvg(redColor)
                        } else {
                            console.log('Ajax error (getNotepadParts) : ' + result.error)
                        }
                    },
                    (error) => {
                        console.log('Ajax error (getNotepadParts) : ' + error)
                    }
                )

            return true
        } else {
            dispatch(addNotepadPart({ hash: hash }))
        }
    }

    const removeNotepadPartHandler = (id, hash) => (e) => {
        if (isProd) {
            const sessid = window.BX.bitrix_sessid()
            const ajaxNotepadUrl = '/bitrix/components/linemedia.auto/personal.notepad/ajax.php'
            const getNotepadPartsUrl = '/ajax/notepad-parts.php?sessid=' + sessid

            const data = new URLSearchParams()
            data.append('notepad', 'delete')
            data.append('id', id)
            data.append('sessid', sessid)

            axios
                .post(ajaxNotepadUrl, data)
                .then(() => fetch(getNotepadPartsUrl))
                .then((res) => res.json())
                .then(
                    (result) => {
                        if (result.result) {
                            dispatch(setNotepadParts(result.data))

                            if (result.data.length === 0) {
                                fillHeaderInfoStarSvg()
                            }
                        } else {
                            console.log('Ajax error (getNotepadParts) : ' + result.error)
                        }
                    },
                    (error) => {
                        console.log('Ajax error (getNotepadParts) : ' + error)
                    }
                )

            return true
        } else {
            dispatch(removeNotepadPart({ hash: hash }))
        }
    }

    return (
        <div
            className="result-table__info-star"
            onClick={
                isPartInNotepad
                    ? removeNotepadPartHandler(partInNotepad['id'], hash)
                    : addNotepadPartHandler(part_id, hash)
            }
        >
            {isPartInNotepad ? (
                <svg
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.99984 13.3917L14.1498 16.5L12.7832 10.6417L17.3332 6.69999L11.3415 6.19166L8.99984 0.666656L6.65817 6.19166L0.666504 6.69999L5.2165 10.6417L3.84984 16.5L8.99984 13.3917Z"
                        fill="#EF4A3D"
                    />
                </svg>
            ) : (
                <svg
                    width="18"
                    height="17"
                    viewBox="0 0 18 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.3332 6.7L11.3415 6.18333L8.99984 0.666666L6.65817 6.19167L0.666504 6.7L5.2165 10.6417L3.84984 16.5L8.99984 13.3917L14.1498 16.5L12.7915 10.6417L17.3332 6.7ZM8.99984 11.8333L5.8665 13.725L6.69984 10.1583L3.93317 7.75833L7.58317 7.44167L8.99984 4.08333L10.4248 7.45L14.0748 7.76667L11.3082 10.1667L12.1415 13.7333L8.99984 11.8333Z"
                        fill="#B0B0AD"
                    />
                </svg>
            )}
        </div>
    )
}

export default InfoStar
